import { Project } from '@/app/api';
import NewProjectCTABanner from '@/app/components/NewProjectCTABanner/NewProjectCTABanner';
import ProjectCard from '@/app/components/ProjectCard/ProjectCard';

type MoreStoriesProps = {
  projects: Project[];
  title: string;
};

export const MoreStories = ({ projects, title }: MoreStoriesProps) => {
  return (
    <div>
      <h2 className="h-[60px] lg:h-[80px] text-center mb-[40px] text-balance text-[24px] lg:text-[32px] leading-[32px] lg:leading-[40px] bg-[url('/public/images/wave-long.svg')] bg-no-repeat bg-bottom">
        {title}
      </h2>
      <div className="overflow-x-auto flex lg:flex-wrap mx-[-24px] ml-[-38px] mb-[32px] lg:mb-[80px] px-[24px]">
        {projects.map((project) => (
          <ProjectCard
            key={project.id}
            title={project.content.currentName}
            image={project.content.mainPhoto ?? undefined}
            href={`/${project.slug}`}
            currentAmountInCents={project.statistics.currentAmountInCents}
            targetAmountInCents={project.statistics.targetAmountInCents ?? undefined}
            donationsCount={project.statistics.donationsCount}
            className="ml-[16px] mb-[16px]"
          />
        ))}
      </div>
      <NewProjectCTABanner />
    </div>
  );
};
